import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { state, style, trigger, transition, animate } from '@angular/animations';
import { Store } from '@ngrx/store';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { AppState } from '@store/state';
import { selectFullscreenLoaderProps, selectFullscreenLoaderVisibility } from '@store/fullscreen-loader/fullscreen-loader.selectors';
import { FullScreenLoaderEnum } from '@enums/fullscreen-loader.enum';
import { LoaderAnimationEnum } from '@enums/loader-animation.enum';

@Component({
  selector: 'app-fullscreen-loader',
  templateUrl: './fullscreen-loader.component.html',
  styleUrls: ['./fullscreen-loader.component.scss'],
  animations: [
    trigger('fullscreenVisibilityTrigger', [
      transition(':enter', [style({ opacity: 0 }), animate(LoaderAnimationEnum.DEFAULT, style({ opacity: 1 }))]),
      transition(':leave', [animate(LoaderAnimationEnum.DEFAULT, style({ opacity: 0 }))]),
    ]),
  ],
})
export class FullscreenLoaderComponent implements OnInit, OnDestroy {
  isVisible: boolean;
  loaderType: string = FullScreenLoaderEnum.DEFAULT;
  contentfulMessageKey: string;
  contentfulBody: string;
  loaderEnum = FullScreenLoaderEnum;
  private unsubscribeAll$: Subject<void> = new Subject();

  constructor(@Inject(Store) private _store: Store<AppState>) {}

  ngOnInit(): void {
    this._store
      .select(selectFullscreenLoaderVisibility)
      .pipe(takeUntil(this.unsubscribeAll$))
      .subscribe((isVisible) => (this.isVisible = isVisible));

    this._store
      .select(selectFullscreenLoaderProps)
      .pipe(takeUntil(this.unsubscribeAll$))
      .subscribe((loaderProps) => {
        if (loaderProps) {
          this.loaderType = loaderProps.loaderType;
          this.contentfulMessageKey = loaderProps.messageKey;
          this.contentfulBody = loaderProps.contentfulBody;
        } else {
          this.loaderType = FullScreenLoaderEnum.DEFAULT;
          this.contentfulMessageKey = null;
          this.contentfulBody = null;
        }
      });
  }

  ngOnDestroy(): void {
    this.unsubscribeAll$.next();
    this.unsubscribeAll$.complete();
  }
}
